module.exports = __webpack_public_path__ + "img/linux.9180c806.svg";